<template>
  <div class="selector-wrapper plain-variants-container">
    <div class="option-wrapper" v-if="form.options.length > 0 && shouldDisplayOptions()">
      <template v-for="(option, i) in form.options" v-bind="i">
        <div :key="i">
          <h4>{{ option.name }}</h4>
          <VariantCustomSelect
            :options="option"
            :selected="selected"
            @dropdownselection="selectedVariant($event, i)"
          />
        </div>
      </template>
    </div> 
    <div class="">
      <ProductAddToCartButton
        :selected-product="atcProduct"
        :hide-border="true"
        :show-shipping="true"
        :shipping="shipping"
        :product-attributes="{}"
        :is-templated="false"
      />
    </div>
  </div>
</template>
<script>
import VariantCustomSelect from "./VariantCustomSelect.vue";
import ProductAddToCartButton from "./ProductAddToCartButton.vue";
export default {
  name: "ProductSelectorVariable",
  data() {
    return {
      variants: "",
      options: "",
      selected: [],
      atcProduct: {},
      form: {
        selections: [],
        options: [],
      },
      container: null,
    };
  },
  props: {
    activeProduct: Object,
    defaultVariant: Object,
    shipping: Object,
  },
  components: {
    VariantCustomSelect,
    ProductAddToCartButton,
  },
  created() {
    this.formOptions();
    this.atcProductCompare();
  },
  mounted() {
    this.atcProductCompare();
    this.triggerUIUpdates(this.atcProduct)
    document.addEventListener("DOMContentLoaded", () => {
        document.dispatchEvent(
          new CustomEvent("appBasedImageChange", {
            detail: { variant: this.atcProduct, alternate: true },
          })
        );
    });
  },
  methods: {
    shouldDisplayOptions() {
      // This variable product only has no child options, as this is the default shopify creates in this situation
      if (this.selected[0] === "Default Title") return false;
      return true;
    },
    atcProductCompare() {
      let changed = false
      let partialMatch = undefined
      this.activeProduct.variants.forEach((variant) => {
        if (
          variant.option1 === this.selected[0] &&
          variant.option2 === this.selected[1] &&
          variant.option3 === this.selected[2]
        ) {
          changed = true
          this.atcProduct = variant;
          this.updateSlider(variant);
          this.$emit("variant-selected", variant);
          this.updateFormOptions()
        }
        // This is to handle partial matches if the variant doesn't exist
        // This will use the first matching variant
        else if ((variant.option2 === this.selected[1] ||
          variant.option3 === this.selected[2]) && !partialMatch) {
            partialMatch = variant
          }
      });
      if (!changed && partialMatch) {
          this.atcProduct = partialMatch;
          this.updateSlider(partialMatch);
          this.$emit("variant-selected", partialMatch);
          this.updateFormOptions()
      }
    },
    updateFormOptions() {
      if (this.atcProduct.option2) {
        this.form.options[0].values = []
      }
      // Going to make the first one dependant on the second one
      this.activeProduct.variants.map((variant) => {
        if (variant.option1.length) {
          if (variant.option2.length && this.atcProduct.option2 == variant.option2) {
            if (this.form.options[0].values.indexOf(variant.option1) == -1) {
              this.form.options[0].values.push(variant.option1);
            }
            this.form.options[0].values = this.form.options[0].values.sort(
              (optionA, optionB) => (optionA > optionB ? 1 : -1)
            );
          }
          else if (variant.option3.length && this.atcProduct.option3 == variant.option3) {
            if (this.form.options[0].values.indexOf(variant.option1) == -1) {
              this.form.options[0].values.push(variant.option1);
            }
            this.form.options[0].values = this.form.options[0].values.sort(
              (optionA, optionB) => (optionA > optionB ? 1 : -1)
            );
          }
        }
      });
    },
    updateSlider(newVariant) {
        document.dispatchEvent(
          new CustomEvent("appBasedImageChange", {
            detail: { variant: newVariant, alternate: true },
          })
        );
    },
    selectedVariant(e, idx) {
      this.selected[idx] = e;
      this.atcProductCompare();
      this.triggerUIUpdates(this.atcProduct)
    },
    formOptions() {
      let position = 0;
      // adds the options titles to data
      for (let key in this.activeProduct) {
        if (key.includes("Label") && this.activeProduct[key].length > 0) {
          position++;
          let val = this.activeProduct[key];
          this.form.options.push({ name: val, position: position, values: [] });
        }
      }
      // adds the options values to data
      this.activeProduct.variants.map((variant) => {
        if (variant.variantId === this.defaultVariant.variantId) {
          this.selected.push(variant.option1);
          this.selected.push(variant.option2);
          this.selected.push(variant.option3);

          this.form.selections = this.selected;
        }
        if (variant.option1.length) {
          if (this.form.options[0].values.indexOf(variant.option1) == -1) {
            this.form.options[0].values.push(variant.option1);
          }
          this.form.options[0].values = this.form.options[0].values.sort(
            (optionA, optionB) => (optionA > optionB ? 1 : -1)
          );
        }
        if (variant.option2.length) {
          if (this.form.options[1].values.indexOf(variant.option2) == -1) {
            this.form.options[1].values.push(variant.option2);
          }
          this.form.options[1].values = this.form.options[1].values.sort(
            (optionA, optionB) => (optionA > optionB ? 1 : -1)
          );
        }
        if (variant.option3.length) {
          if (this.form.options[3].values.indexOf(variant.option3) == -1) {
            this.form.options[3].values.push(variant.option3);
          }
          this.form.options[2].values = this.form.options[2].values.sort(
            (optionA, optionB) => (optionA > optionB ? 1 : -1)
          );
        }
      });
    },
    triggerUIUpdates(product) {
      if (product) {
        document.dispatchEvent(new CustomEvent('bmm-product-update', {
          detail: { price: product.price, normalPrice: product.sPrice },
        }))
      }
    }
  },
};
</script>
<style scoped>
.plain-variants-container {
  text-align: left;
}
.option-wrapper {
    border-bottom: 1px solid #cbcbc3;
    margin: 0 20px;
}
.option-wrapper:first-of-type {
  border-top: 1px solid #cbcbc3;
}
.plain-variants-container h4 {
  font-family: var(--oddit-main-font);;
  font-weight: 500;
  font-size: 18px;
  line-height: 150%;
  letter-spacing: 0.25px;
  margin: 12px 0;
}
.selector-wrapper {
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
}
@media screen and (min-width: 768px) {
  .plain-variants-container {
    border: 1px solid #cbcbc3;
    
  }
  .option-wrapper {
    padding: 0 24px 10px;
    margin: 0;
  }
  .option-wrapper:first-of-type {
    border-top: none;
  }
}
@media screen and (min-width: 1024px) {
  .selector-wrapper {
    margin-left: unset;
  }
}

</style>
